// extracted by extract-css-chunks-webpack-plugin
module.exports = {"thumbnail":"thumbnail___2Flzx","overlay":"overlay___5yNR_","play":"play___2y7Om","expand":"expand___35J_X"};